import * as React from 'react';
import { Icon } from '../icons.jsx';
import { Badge, Button } from '../ui.jsx';

const OFFICIAL_LINKS = {
  apply: 'https://www.pa.gov/services/dhs/apply-for-child-care-works-subsidized-child-care',
  compass: 'https://www.compass.dhs.pa.gov/home/#/',
  elrc: 'https://www.pa.gov/agencies/dhs/resources/early-learning-child-care/elrc',
};

const OfficialLink = ({ href, children, primary = false }) => (
  <a
    className={`resource-link ${primary ? 'is-primary' : ''}`}
    href={href}
    target="_blank"
    rel="noreferrer"
  >
    {children}
    <Icon name="arrow-right" size={15}/>
  </a>
);

export const ResourcesScreen = ({ go }) => (
  <div className="resources-page route-in">
    <section className="resources-hero">
      <div className="container resources-hero-grid">
        <div>
          <Badge tone="brand" icon="shield">Pennsylvania family resources</Badge>
          <h1>Help paying for child care</h1>
          <p>
            Child Care Works may help eligible Pennsylvania families pay for care.
            Find My Childcare can help you find providers, but Pennsylvania and your local
            Early Learning Resource Center handle eligibility and applications.
          </p>
          <div className="resources-actions">
            <OfficialLink href={OFFICIAL_LINKS.apply} primary>Start on PA.gov</OfficialLink>
            <OfficialLink href={OFFICIAL_LINKS.compass}>Open COMPASS</OfficialLink>
          </div>
        </div>
        <aside className="resource-help-card">
          <Icon name="phone" size={22}/>
          <span>Child Care Works helpline</span>
          <a href="tel:+18774725437">1-877-4-PA-KIDS</a>
          <small>1-877-472-5437</small>
        </aside>
      </div>
    </section>

    <section className="container resources-content">
      <div className="resource-steps" aria-labelledby="resource-steps-title">
        <div className="resource-section-heading">
          <span>A simpler starting point</span>
          <h2 id="resource-steps-title">Three steps to official help</h2>
        </div>
        <ol>
          <li>
            <span>1</span>
            <div>
              <h3>Read the Pennsylvania overview</h3>
              <p>
                Review current eligibility information and what you may need before applying.
              </p>
              <OfficialLink href={OFFICIAL_LINKS.apply}>View Child Care Works on PA.gov</OfficialLink>
            </div>
          </li>
          <li>
            <span>2</span>
            <div>
              <h3>Apply through COMPASS</h3>
              <p>
                COMPASS is Pennsylvania’s official application portal. Find My Childcare does
                not determine eligibility or collect your benefits application.
              </p>
              <OfficialLink href={OFFICIAL_LINKS.compass}>Go to COMPASS</OfficialLink>
            </div>
          </li>
          <li>
            <span>3</span>
            <div>
              <h3>Contact your local ELRC</h3>
              <p>
                Early Learning Resource Centers answer questions, process Child Care Works,
                and help families understand local options.
              </p>
              <OfficialLink href={OFFICIAL_LINKS.elrc}>Find your ELRC</OfficialLink>
            </div>
          </li>
        </ol>
      </div>

      <aside className="resource-search-panel">
        <Badge tone="open" icon="live">Find care next</Badge>
        <h2>Look for providers that show subsidy participation</h2>
        <p>
          Search results can help you identify programs to contact. Participation and openings
          should still be confirmed with the provider and your ELRC.
        </p>
        <Button full onClick={() => go('results')} icon="search">Search child care</Button>
        <button type="button" onClick={() => go('requests')}>Already contacted a provider? Check your requests</button>
      </aside>
    </section>

    <section className="container resource-trust">
      <Icon name="shield" size={20}/>
      <div>
        <strong>Official handoff, not a replacement</strong>
        <p>
          Eligibility rules and application status come from Pennsylvania. Find My Childcare
          adds current provider availability, tours, and waitlists around that official process.
        </p>
      </div>
    </section>
  </div>
);
